<template>
  <p>{{ $t('hello') }}</p>
</template>

<script>
import http from '@/utils/http'
import config from '@/utils/config'

export default {
  name: 'HelloI18n',

}
</script>

<i18n>
{
  "en": {
    "hello": "Hello i18n in SFC!"
  }
}
</i18n>
